import { useLocation } from 'react-router-dom'
import HandIcon from 'assets/images/easyPay/init.svg'
import Header from 'components/headers/addLoan'
import style from './final.module.scss'
import useSEtFinalCashout from '../hooks/useSEtFinalCashout'
import useSetCashouts from '../hooks/useSetCashouts'
export default function Final() {
    const { state } = useLocation()
    const { mutate } = useSEtFinalCashout()
    const { mutate: mutateJustAdd } = useSetCashouts()
    return (
        <div className=" h-screen relative flex flex-col">
            <div className=" grow-0">
                <Header title="" />
            </div>
            <div className=" grow">
                <div className=" relative">
                    <img
                        src={HandIcon}
                        alt="hand"
                        className=" mx-auto absolute -top-16 z-50 right-32"
                    />

                    <div className={style['StyledReceipt']}>
                        <div>
                            <p className=" text-gray-1">واریز به حساب:</p>
                            <p>{state?.data?.name}</p>
                        </div>
                        <hr className=" my-2" />
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">مبلغ:</p>
                            <p>
                                {state?.data?.amount &&
                                    Number(
                                        state?.data?.amount
                                    ).toLocaleString()}{' '}
                                تومان
                            </p>
                        </div>
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">هزینه اشتراک:</p>
                            <p>0 تومان</p>
                        </div>
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1"> بابت:</p>
                            <p>ّبرداشت از صندوق</p>
                        </div>

                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1">نام صندوق:</p>
                            <p>{state?.data?.fundName}</p>
                        </div>

                        <hr className=" my-4" />
                        <div className=" flex justify-between mt-4">
                            <p className=" text-gray-1"> مبلغ:</p>
                            <p>
                                {state?.data?.amount &&
                                    Number(
                                        state?.data?.amount
                                    ).toLocaleString()}{' '}
                                تومان
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" grow-0">
                <div className=" w-full">
                    <div className=" w-full">
                        <div
                            className=" mx-8 rounded-xl  bg-green-1 text-white text-center py-2.5 my-2 cursor-pointer"
                            onClick={() => {
                                const payload: IGetCardsPayloadFinal = {
                                    registrar: state?.data?.registrar,
                                    poolship: state?.data?.poolship,
                                    amount: state?.data?.amount,
                                    reason: state?.data?.reason,
                                    moneyPool: state?.data?.moneyPool,
                                    tag: state?.data?.tag,
                                    bank_account: state?.data?.bank_account,
                                    ctx_id: state?.data?.ctx_id,
                                    receiver: state?.data?.receiver,
                                    name: state?.data?.name,
                                    fundName: state?.data?.fullName,
                                }
                                mutate(payload)
                            }}
                        >
                            برداشت
                        </div>
                    </div>
                    <div className=" w-full">
                        <div
                            onClick={() => {
                                const payload: IGetCardsPayloadFinal = {
                                    registrar: state?.data?.registrar,
                                    poolship: state?.data?.poolship,
                                    amount: state?.data?.amount,
                                    reason: state?.data?.reason,
                                    moneyPool: state?.data?.moneyPool,
                                    tag: state?.data?.tag,
                                    bank_account: state?.data?.bank_account,
                                    ctx_id: state?.data?.ctx_id,
                                    receiver: state?.data?.receiver,
                                    name: state?.data?.name,
                                    fundName: state?.data?.fullName,
                                }
                                mutateJustAdd(payload)
                            }}
                            className=" mx-8 rounded-xl  bg-transparent text-green-1 text-center py-2.5 my-2 cursor-pointer border-1 border-green-1"
                        >
                            برداشت تنها ثبت شود
                        </div>
                    </div>
                </div>{' '}
            </div>
        </div>
    )
}
